import React, { useEffect, useState, useRef } from 'react';
import { Typography, IconButton } from '@material-tailwind/react';
import { useLanguage } from '../contexts/LanguageContext';
import { languages } from '../languages';
import ReactMarkdown from 'react-markdown';
import { brandNameChat, mcDePageClass } from '../utils/branding';

const ChatScreen = () => {
    const { language } = useLanguage();

    // Map Belgian language codes to french and nederlands
    let translationLanguage = language;
    if (language === 'befr' || language === 'be-fr') {
        translationLanguage = 'french';
    } else if (language === 'benl' || language === 'be-nl') {
        translationLanguage = 'nederlands';
    } else if (language === 'bh-ar' || language === 'bahrain-arabic') {
        translationLanguage = 'arabic';
    } else if (language === 'bh-en' || language === 'bahrain-english') {
        translationLanguage = 'english';
    } else if (language === 'uae-ar' || language === 'uae-arabic') {
        translationLanguage = 'arabic';
    } else if (language === 'uae-en' || language === 'uae-english') {
        translationLanguage = 'english';
    } else if (language === 'sa-ar' || language === 'sa-arabic') {
        translationLanguage = 'arabic';
    } else if (language === 'sa-en' || language === 'sa-english') {
        translationLanguage = 'english';
    } else if (language === 'kw-ar' || language === 'kw-arabic') {
        translationLanguage = 'arabic';
    } else if (language === 'kw-en' || language === 'kw-english') {
        translationLanguage = 'english';
    } else if (language === 'qa-ar' || language === 'qa-arabic') {
        translationLanguage = 'arabic';
    } else if (language === 'qa-en' || language === 'qa-english') {
        translationLanguage = 'english';
    } else if (language === 'om-ar' || language === 'om-arabic') {
        translationLanguage = 'arabic';
    } else if (language === 'om-en' || language === 'om-english') {
        translationLanguage = 'english';
    } else if (language === 'iq-ar' || language === 'iq-arabic') {
        translationLanguage = 'arabic';
    } else if (language === 'iq-en' || language === 'iq-english') {
        translationLanguage = 'english';
    } else if (language === 'jo-ar' || language === 'jo-arabic') {
        translationLanguage = 'arabic';
    } else if (language === 'jo-en' || language === 'jo-english') {
        translationLanguage = 'english';
    } else if (language === 'lb-ar' || language === 'lb-arabic') {
        translationLanguage = 'arabic';
    } else if (language === 'lb-en' || language === 'lb-english') {
        translationLanguage = 'english';
    } else if (language === 'sy-ar' || language === 'sy-arabic') {
        translationLanguage = 'arabic';
    } else if (language === 'sy-en' || language === 'sy-english') {
        translationLanguage = 'english';
    } else if (language === 'ps-ar' || language === 'ps-arabic') {
        translationLanguage = 'arabic';
    } else if (language === 'ps-en' || language === 'ps-english') {
        translationLanguage = 'english';
    } else if (language === 'ye-ar' || language === 'ye-arabic') {
        translationLanguage = 'arabic';
    } else if (language === 'ye-en' || language === 'ye-english') {
        translationLanguage = 'english';
    } else if (language === 'eg-ar' || language === 'eg-arabic') {
        translationLanguage = 'arabic';
    } else if (language === 'eg-en' || language === 'eg-english') {
        translationLanguage = 'english';
    } else if (language === 'pl-pl') {
        translationLanguage = 'polish';
    } else if (language === 'cyprus' || language === 'cy' || language === 'el-cy') {
        translationLanguage = 'greek';
    }

    // Get translations with fallback
    const t = languages[translationLanguage] || languages['english'];
    const [input, setInput] = useState('');
    const [messages, setMessages] = useState([]);
    const [threadId, setThreadId] = useState('');
    const [loading, setLoading] = useState(false);
    const messagesEndRef = useRef(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
    const [isInitialized, setIsInitialized] = useState(false);
    const [tempAskRecipe, setTempAskRecipe] = useState(null);
    const [tempAskCookbook, setTempAskCookbook] = useState(null);

    useEffect(() => {
        const storedTempAskRecipe = localStorage.getItem('tempAskRecipe');
        if (storedTempAskRecipe) {
            try {
                const parsedRecipe = JSON.parse(storedTempAskRecipe);
                setTempAskRecipe(parsedRecipe);
                console.log('Loaded tempAskRecipe:', parsedRecipe);
                // Clear existing messages and threadId when tempAskRecipe is loaded
                setMessages([]);
                setThreadId('');
            } catch (error) {
                console.error('Error parsing tempAskRecipe:', error);
                localStorage.removeItem('tempAskRecipe');
            }
        }
    }, []);

    useEffect(() => {
        const storedTempAskCookbook = localStorage.getItem('tempAskCookbook');
        if (storedTempAskCookbook) {
            try {
                const parsedCookbook = JSON.parse(storedTempAskCookbook);
                setTempAskCookbook(parsedCookbook);
                console.log('Loaded tempAskCookbook:', parsedCookbook);
                // Wis bestaande berichten en threadId als er een kookboek is geladen
                setMessages([]);
                setThreadId('');
            } catch (error) {
                console.error('Error parsing tempAskCookbook:', error);
                localStorage.removeItem('tempAskCookbook');
            }
        }
    }, []);


    useEffect(() => {
        if (isInitialized) {
            return;
        }

        const initializeChat = () => {
            console.log('Initializing chat...');

            if (tempAskCookbook) {
                console.log('tempAskCookbook is present, initializing chat with cookbook question');
                const cookbookName = tempAskCookbook.name;
                const initialMessageText = `${t.askingAboutCookbook} ${cookbookName}\n\n${t.whatQuestionWouldYouLikeToAsk}`;
                const initialMessage = {
                    sender: 'system',
                    text: initialMessageText,
                };
                setMessages([initialMessage]);
                setThreadId('');
            } else {
                // Bestaande logica voor het laden van chatgegevens
            }
            setIsInitialized(true);
        };

        initializeChat();
    }, [tempAskCookbook, isInitialized, t]);


    useEffect(() => {
        if (isInitialized) {
            return;
        }

        const initializeChat = () => {
            console.log('Initializing chat...');

            if (tempAskRecipe) {
                console.log('tempAskRecipe is present, initializing chat with recipe question');
                const recipeName = tempAskRecipe.recipe.name;
                const initialMessageText = `${t.askingAboutRecipe} ${recipeName}\n\n${t.whatQuestionWouldYouLikeToAsk}`;
                const initialMessage = {
                    sender: 'system',
                    text: initialMessageText,
                };
                setMessages([initialMessage]);
                setThreadId('');
            } else {
                const chatData = localStorage.getItem('chatBotData');
                console.log('Retrieved chatData:', chatData);

                if (chatData) {
                    try {
                        const parsedData = JSON.parse(chatData);
                        setMessages(parsedData.messages);
                        setThreadId(parsedData.threadId || '');
                        console.log('Chat data loaded successfully');
                    } catch (error) {
                        console.error('Error parsing chatData:', error);
                        setDefaultChatState();
                    }
                } else {
                    console.log('No existing chat data found and no tempAskRecipe, setting default state');
                    setDefaultChatState();
                }
            }
            setIsInitialized(true);
        };

        initializeChat();
    }, [tempAskRecipe, isInitialized, t]);

    // useEffect for window resize and cleanup
    useEffect(() => {
        const checkIfMobile = () => {
            setIsMobile(window.innerWidth < 1024);
        };

        window.addEventListener('resize', checkIfMobile);

        return () => {
            window.removeEventListener('resize', checkIfMobile);

        };
    }, []);

    useEffect(() => {
        if (isInitialized) {
            const chatData = { messages, threadId };
            localStorage.setItem('chatBotData', JSON.stringify(chatData));
            console.log('Saved chatData:', chatData);
        }
    }, [messages, threadId, isInitialized]);

    const setDefaultChatState = () => {
        const welcomeMessage = {
            sender: 'bot',
            text: t.chatBotIntro || `Welcome, I am ${brandNameChat}. Ask me anything!`,
        };
        setMessages([welcomeMessage]);
        setThreadId('');
        localStorage.setItem(
            'chatBotData',
            JSON.stringify({ messages: [welcomeMessage], threadId: '' })
        );
    };

    const handleInputChange = (event) => {
        setInput(event.target.value);
    };

    const deleteConversation = () => {
        setDefaultChatState();
        setInput('');
        setTempAskRecipe(null);
        localStorage.removeItem('tempAskRecipe');
        setTempAskCookbook(null);
        localStorage.removeItem('tempAskCookbook');
    };


    const sendMessageToBot = async (input, tempAskRecipe) => {
        setLoading(true);

        try {
            const response = await fetch('/api/ai/chat', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    message: input,
                    thread_id: threadId,
                    recipe: tempAskRecipe ? JSON.stringify(tempAskRecipe.recipe) : undefined,
                    cookbook: tempAskCookbook ? JSON.stringify(tempAskCookbook) : undefined,
                    language: translationLanguage,
                }),
            });
            const data = await response.json();
            setLoading(false);
            return data;
        } catch (error) {
            console.error('Error fetching from AI chat:', error);
            setLoading(false);
            return {
                bot: t.errorFetchingData || 'There was an error fetching data',
                thread_id: threadId,
            };
        }
    };

    const sendMessage = async () => {
        if (input.trim() === '') return;

        const userMessage = { sender: 'user', text: input };
        setMessages((prevMessages) => [...prevMessages, userMessage]);
        setInput('');

        const responseData = await sendMessageToBot(input, tempAskRecipe, tempAskCookbook);

        const botMessage = { sender: 'bot', text: responseData.bot };
        setMessages((prevMessages) => [...prevMessages, botMessage]);
        setThreadId(responseData.thread_id);

        // Wis tempAskCookbook na het verzenden van het bericht
        if (tempAskCookbook) {
            setTempAskCookbook(null);
            localStorage.removeItem('tempAskCookbook');
            console.log('tempAskCookbook gewist na het verzenden van bericht');
        }
    };



    return (
        <div className={`flex flex-col  bg-white shadow rounded-md ${mcDePageClass(language)}`}>
            {/* Header Section */}
            <div className="h-16 flex justify-between items-center p-4 bg-white rounded-lg">
                <Typography variant='h4' className={`text-md`}>{t.chatWithSousChaif || `Chat with ${brandNameChat}`}</Typography>
                <IconButton
                    color="blue-gray"
                    variant='text'
                    onClick={deleteConversation}
                    className="text-lg"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
                    </svg>
                </IconButton>
            </div>

            {/* Messages Section (Scrollable) */}
            <div className="overflow-y-auto h-[calc(100vh-330px)] p-4">
                {tempAskRecipe && (
                    <div className="mb-4">
                        <div className="inline-block p-3 rounded-lg bg-gray-200 dark:bg-gray-700 dark:text-white">
                            <Typography variant="h5" >{tempAskRecipe.recipe.name}</Typography>
                            {tempAskRecipe.imageData && (
                                <img
                                    src={`data:image/jpeg;base64,${tempAskRecipe.imageData}`}
                                    alt={tempAskRecipe.recipe.name}
                                    className="w-full h-auto mt-2"
                                />
                            )}
                            <Typography variant="paragraph" className="mt-2">
                                {t.whatQuestionWouldYouLikeToAsk || 'What question would you like to ask?'}
                            </Typography>
                        </div>
                    </div>
                )}

                {tempAskCookbook && (
                    <div className="mb-4">
                        <div className="inline-block p-3 rounded-lg bg-gray-200 dark:bg-gray-700 dark:text-white">
                            <Typography variant="h5">{tempAskCookbook.name}</Typography>
                            {tempAskCookbook.image && (
                                <img
                                    src={tempAskCookbook.image}
                                    alt={tempAskCookbook.name}
                                    className="w-full h-auto mt-2"
                                />
                            )}
                            <Typography variant="paragraph" className="mt-2">
                                {t.whatQuestionWouldYouLikeToAsk || 'What question would you like to ask?'}
                            </Typography>
                        </div>
                    </div>
                )}


                {!tempAskRecipe && !tempAskCookbook && messages.map((message, index) => (
                    <div
                        key={index}
                        className={`mb-4 ${message.sender === 'user' ? 'text-right' : 'text-left'}`}
                    >
                        <div
                            className={`inline-block p-3 rounded-lg ${message.sender === 'user'
                                ? 'bg-green-400 text-white'
                                : 'bg-gray-200'
                                }`}
                        >
                            <ReactMarkdown className="flex flex-col gap-2 text-sm">
                                {message.text}
                            </ReactMarkdown>
                        </div>
                    </div>
                ))}
                {loading && (
                    <div className="loader-dots text-center">
                        <div className="loader-dot"></div>
                        <div className="loader-dot"></div>
                        <div className="loader-dot"></div>
                    </div>
                )}
                <div ref={messagesEndRef} />
            </div>

            {/* Input Section */}
            <div className="h-20 p-4 bg-white rounded-lg">
                <div className="flex gap-2 items-center justify-between">
                    <input
                        type="text"
                        value={input}
                        onChange={handleInputChange}
                        disabled={loading}
                        placeholder={t.typeYourMessage || 'Type your message...'}
                        className="flex-1 p-2 bg-white border rounded"
                        onKeyPress={(event) => (event.key === 'Enter' ? sendMessage() : null)}
                    />
                    <IconButton
                        onClick={sendMessage}
                        disabled={loading}
                        size="lg"
                        className="bg-green-400 text-white rounded-full"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5" />
                        </svg>
                    </IconButton>
                </div>
            </div>
        </div>
    );
};

export default ChatScreen;
